import React from 'react';
import { ContentHeadingProps } from '../../models/TopLevelTemplateComponentProps';
import { headingSet } from '../../services/TemplateUtils';
import { Palette } from 'Palette';
import { StyledHeading } from '../styles/styles';

interface StandardHeaderHeadingBlockProps {
  heading: ContentHeadingProps;
  tone?: keyof typeof Palette;
}

export default function StandardHeaderHeadingBlock({
  heading,
  tone,
}: StandardHeaderHeadingBlockProps) {
  if (!headingSet(heading)) return null;
  return (
    <StyledHeading tone={tone} headerVariant="heading2">
      {heading.content}
    </StyledHeading>
  );
}
